import api from "../api";

export default {
    show(contingent) {
        return api.get(`/central/contingents/${contingent}`)
    },

    update(contingent, data) {
        return api.patch(`/central/contingents/${contingent}`, data)
    },
}